// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3928":"plone-volto-components-theme-InjectPloneComponentsCSS-InjectPloneComponentsCSS","4328":"Widgets","5772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"3928":"feec91df","4328":"86324ec9","5772":"2b1266ba"}[chunkId] + ".chunk.css";
};